import { render, staticRenderFns } from "./CertificateQuarter.vue?vue&type=template&id=105e0148&scoped=true"
import script from "./CertificateQuarter.vue?vue&type=script&lang=js"
export * from "./CertificateQuarter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105e0148",
  null
  
)

export default component.exports